import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import plTranslation from './i18n/pl.json';
import enTranslation from './i18n/en.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            pl: {
                translation: plTranslation
            },
            en: {
                translation: enTranslation
            }
        },
        lng: localStorage.getItem('language') || 'pl',
        fallbackLng: 'pl',
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
